export const GET_TIMEZONE_REQUEST = 'GET_TIMEZONE_REQUEST';
export const GET_TIMEZONE_SUCCESS = 'GET_TIMEZONE_SUCCESS';
export const GET_TIMEZONE_ERROR = 'GET_TIMEZONE_ERROR';

export const GET_ALL_TIMEZONE_REQUEST = 'GET_ALL_TIMEZONE_REQUEST';
export const GET_ALL_TIMEZONE_SUCCESS = 'GET_ALL_TIMEZONE_SUCCESS';
export const GET_ALL_TIMEZONE_ERROR = 'GET_ALL_TIMEZONE_ERROR';
